import Styled from 'styled-components';

import { media } from '../../lib/StyledComponents';

export const HeaderLogo = Styled.div`
  img,
  svg {
    width: 100%;
    max-width: 10em;
    display: inline-block;
    vertical-align: middle;
  }

  ${media.medium`
    max-width: 12em;
  `}
`;
